// specific javascript for quotes form.  Removed from 'create.phtml' for cleaner code.

bq.quotes = function(element, options) {
    this.$element = $(element);
    this.options = options;
    this.isUrlAllowChange = false;
};

bq.quotes.DEFAULTS = {};

bq.quotes.prototype = {
    tableCount: 0,
    form: $('#create-quote-form'),
    addRowLink: $('#add-row'),

    init: function() {
        var $self = this;
        this.tableCount = this.form.find('.fieldset-table').length; // In edit mode we have some tables already
        var unspscSelect2Options = bq.quotes.setUnspsc;
        var search2Term = '';
        var placeholder = this.form.data('placeholder');

        /* -- Setup Select2 Dropdowns -- */
        if ($('select.unit_of_measure').length) {
            $('select.unit_of_measure').select2();
        }
        if ($('input.unspsc.select-box').length) {
            $('input.unspsc.select-box').select2(unspscSelect2Options);
        }
        if ($('select.itemtype.select-box').length) {
            $('select.itemtype.select-box').select2({minimumResultsForSearch: 3});
        }

        /* -- Switch Form Type (Catalog vs. Non-Catalog) -- */
        this.form.on('click', '.non-catalog_product, .catalog_product', function(){
            var $this = $(this),
               $table = $self.form,
            className = $this.attr('class'),
                 rows = $this.closest('table').children('tbody').children('tr');

            if($this.is(':checked')){
               switch (className){
                    case 'non-catalog_product':
                        rows.addClass('non-catalog');
                        rows.find('.sku').prop('placeholder','').data('validateSku', false).data('lastSku', '');
                        rows.find('.unspsc-container span.select2-chosen').text(unspscSelect2Options.placeholder);
                        rows.find('.itemtype').prop('disabled', null);
                        rows.find('.qty-copy').prop('min', rows.find('.qty-copy').data('minDecQty'));
                        break;
                    case 'catalog_product':
                        rows.find('.itemtype').prop('disabled', 'disabled');
                        rows.find('.sku').prop('placeholder',placeholder).data('validateSku', true).data('lastSku', '');
                        rows.removeClass('non-catalog');
                }

                $self.clearRow(rows);
                $self.form.trigger('bq.gridSummary.change', this);
            }

            bq.initializeJS();
        });

        this.addRowLink.on('click', function(e) {
            e.preventDefault();
            $self.addRow();
            $self.recalculateRemoveClearButtons();
        });

        this.initListeners();

        /* -- Revalidate the rows if the user makes changes -- */
        this.form.on('bq.gridSummary.inputChange',function(){
            if($self.hasItemsFormErrors()){
                $self.validateItemsForm();
            }
        });

        /* -- Remove row functionality -- */
        this.form.on('click', '.remove', function(e){
            var $self = this;
            var $parent = $(this).closest('table');
            var $rows = $parent.children('tbody').children('tr');

            e.preventDefault();
            if($parent.is('table.form-set:first-child')){
                if($('table.form-set').length > 1){
                    $parent.remove();
                } else {
                  bq.quotes.prototype.clearRow($rows);
                }
            } else {
                $parent.remove();
            }

            bq.quotes.prototype.updateSummary();
            bq.quotes.prototype.recalculateRemoveClearButtons();
            //this.initListeners();
        });


        this.form.on('change bq.quickOrder.loadEnd', function(){ $self.update_combo_boxes(); });

        /* -- Form submit functionality -- */
        // submit button, on click event
        $('#create-quote-submit-button').on('click', function(e){
          if($('#create-quote-form').data('submitting')) { return; }

          $('#quote-new').trigger('bq.viewhandler.start');

          $('#create-quote-form').parsley().validate();

          setTimeout(function(){// set timeout to make sure viewhandler gets fired first
            if($('#create-quote-form').data('submitting')) { return; }

            if($self.validateItemsForm() && $self.validateGeneralFields()) {
              $self.form.data('submitting', true);
              $self.setSaveBtn('loading');
              $self.submitQuoteForm();
            } else {
              $('#quote-new').trigger('bq.viewhandler.stop');
              $self.setSaveBtn('');
              $self.form.data('submitting', false);
            }
            }, 200);
        });

        $('.qty-copy').on('keyup', function() {
            if ( $(this).parsley() ) {
                $(this).parsley().validate();
            }
        });

        /* -- Fix Tier Pricing for Customer -- */
        $('#requester_id').on('change', function(e){
            var $quickOrder = $('table.form-set').data('bq.quickOrder');
            $quickOrder.options.ajaxParams = {"requester_id": e.val, "refresh_by_id": "1"};

            if(!$quickOrder) { return; }

            $('table.form-set').each(function(index, el) {
                $(el).trigger('bq.refresh');
            });

            if ($(this).parsley()) {
                $(this).parsley().validate();
            }
        });

        /* -- Uploader Functionality -- */
        $('#fileuploader-form').on('submit',function(e){
            $.ajax({
                url: this.action,
                type: 'POST',
                data: new FormData( this ),
                processData: false,
                contentType: false
            });
            e.preventDefault();
        });

        $('#bqat-btnSubmitUpload').on('click', function(){
            var $form = $('#fileuploader-form');
            var $file = $('#myfile');

            if( !$file.val() ) {
                $self.setFileMessage('Please select a file to upload', 'danger');
            } else if( !(/\.(csv)$/i).test($file.val()) ) {
                $self.setFileMessage('File must be in CSV format. Download sample below.', 'danger');
            } else {
                $self.setFileBtn('loading');
                $self.setFileMessage('', '', true);

                var fd = new FormData();
                fd.append( 'file', $file.prop('files')[0] );

                $.ajax({url: $form.prop('action'), type: 'POST', data: fd, processData: false, contentType: false})
                    .done(function( json ) {
                        var parseError = false;
                        try {
                            json = $.parseJSON(json);
                        }catch (e) {
                            parseError = true;
                        }

                        if( !json || parseError ) {
                            $self.setFileBtn('normal');
                            $self.setFileMessage('Unable to upload file or file is not correct type.', 'danger');
                            return;
                        }

                        if( json.error ) {
                            $self.setFileBtn('normal');
                            $self.setFileMessage(json.message, 'danger');
                        } else {
                            //$('#fileuploader-form')[0].reset();
                            $self.setFileBtn('normal');
                            $self.setFileMessage('', '', true);
                            $('#uploadFileModal').modal('hide');
                            $self.processFile(json);
                        }
                    })
                    .fail(function( jqxhr, textStatus, error ) {
                        var err = textStatus + ", " + error;
                        $self.setFileMessage('Unable to upload file.', 'danger');
                    });
            }
        });

        this.update_combo_boxes();
    },


    /* ============================== */
    /* ==== [FUNCTION] addRow(e) ==== */
    /* ============================== */

    addRow: function() {
        var $self = this;

        this.updateRows();

        $self.form.trigger('bq.gridSummary.change', this);

        /* -- There may be errors for other rows not based on minimum number of items -- */
        if ( this.hasItemQuantityError() ){
            $self.clearItemsError();
        } else {
            $('.qty-copy').on('keyup', function() {
                if ( $(this).parsley() ) {
                    $(this).parsley().validate();
                }
            });
        }
        bq.initializeJS();
        this.initListeners();
    },

    /* ================================= */
    /* ==== [FUNCTION] skuChange(e) ==== */
    /* ================================= */

    initListeners: function(){
        var validationInputClasses = ['unit_of_measure', 'item-price-copy', 'sku', 'name', 'manufacturer_name', 'manufacturer_part_number', 'unspsc', 'qty-copy'];

        /* -- Listen for changes on all the form inputs -- */
        for(var i = 0; i < validationInputClasses.length; i++){
            var element = $('.' + validationInputClasses[i]);
            var $self = this;

            element.on('blur', function(){
                var $this = $(this),
                      $tb = $(this).closest('table'),
                elClasses = $(this).attr('class').split(' '),
                 tableNum = $tb.attr('id');

                //Get table index
                var tableNumParts = tableNum.split('_');
                tableNum = tableNumParts.length > 0 ? tableNumParts[tableNumParts.length -1] : tableNum;

                var $unspsc = $tb.find('.item-unspsc.hidden'),
                       $uom = $tb.find('.item-unit_of_measure.hidden'),
                       $qty = $tb.find('.qty.hidden'),
                     $price = $tb.find('.item-total.hidden'),
                 $itemPrice = $tb.find('.item-price.hidden'),
                 tierPrices = $itemPrice.data('tier_prices'),
                      total = 0;
                var isProduct = $tb.find('input.catalog_product').is(':checked');

                if (isProduct && $this.hasClass('sku')) {
                    checkHidden();
                    var tmpVal = $this.val();
                    $this.attr('value', tmpVal);
                } else if($this.hasClass('unspsc')){
                    $unspsc.val($this.val());
                } else if ($this.hasClass('item-price-copy')){
                    $itemPrice.val($this.val());
                    if($qty.val() == ''){ $qty.val($tb.find('.qty-copy').val()); }
                    total = $this.val() * $qty.val();
                } else if ($this.hasClass('qty-copy')){
                    var itemQty = $this.val(),
                        $currentPrice = $('.item-price-copy', $tb);

                    $qty.val(itemQty);

                    // Process tier prices
                    var applyPrice = $itemPrice.val(),
                        tierQty = 0;
                    if (tierPrices !== undefined) {
                        $.each(tierPrices, function(idx, val){
                            var tierItemQty = parseFloat(val.qty);
                            if (itemQty >= tierItemQty && tierItemQty >= tierQty) {
                                tierQty = tierItemQty;
                                applyPrice = val.price;
                            }
                        });
                    }

                    applyPrice = accounting.toFixed(applyPrice, window.accounting.settings.currency.precision);

                    $currentPrice.val(applyPrice);

                    total = itemQty * $currentPrice.val();

                } else if ($this.hasClass('unit_of_measure')){
                    $uom.val($this.val());
                }

                if($this.hasClass('item-price-copy') || $this.hasClass('qty-copy')){
                    $price.html(accounting.formatMoney(total));
                    $price.attr('data-original-title', total);
                    $tb.find('.total-copy_' + tableNum).text($price.text());
                }

                bq.quotes.prototype.updateSummary();


                function checkHidden(){
                    var $parent = $tb.find('.sku').parent('.form-group');

                    /* -- check to see if sku needs more updating -- */
                    if($parent.hasClass('has-success')){
                        /* -- update price fields once hidden fields are populated -- */
                        $tb.find('.item-price-copy').val($itemPrice.val());

                        var $qtyCopy = $tb.find('.qty-copy');
                        if (parseFloat($qty.attr('min'))) {
                            $qty.val($qty.attr('min'));
                            $qtyCopy.attr('min', $qty.attr('min'));
                        }

                        if (parseFloat($qty.attr('max'))) $qtyCopy.attr('max', $qty.attr('max'));
                        if (parseFloat($qty.val())) $qtyCopy.val($qty.val());

                        total = $itemPrice.val() * $qtyCopy.val();
                        $tb.find('.item-total.hidden').attr('data-original-title', total);
                        $tb.find('.item-total.hidden').val(accounting.formatMoney(total));
                        $tb.find('.total-copy_' + tableNum).text($tb.find('.item-total.hidden').val());
                        $tb.find('.unspsc-copy_' + tableNum).text($tb.find('.item-unspsc.hidden').text());
                        $tb.find('.unit_of_measure-copy_' + tableNum).text($tb.find('.item-unit_of_measure.hidden').text());

                        bq.quotes.prototype.updateSummary();
                        bq.initializeJS();
                    } else {
                        /* -- set static values -- */
                        $tb.find('.unspsc-copy_' + tableNum).text($tb.find('.item-unspsc.hidden').text());
                        $tb.find('.unit_of_measure-copy_' + tableNum).text($tb.find('.item-unit_of_measure.hidden').text());

                        /* -- restart check -- */
                        setTimeout(function(){ checkHidden()}, 500);
                    }
                };
            });
        }

        // remove validation notification for edited fields
        $( "#create-quote-form .form-control" ).change(function(event) {
            var element = event.target;
            var formGroup = $(element).parent('.form-group');

            if (formGroup.length && formGroup.hasClass('has-error')) {
                formGroup.removeClass('has-error has-feedback');
                var spanIcon = $(formGroup).find('.form-validation-error');
                spanIcon.remove();
            }
        });
    },

    /* ===================================================== */
    /* ==== [FUNCTION] updateRowTotals(i, tableElement) ==== */
    /* ===================================================== */

    updateLineTotals: function(i, tableElement) {
        var $tb = $(tableElement);
        var tableNum = $tb.attr('id');
        //Get table index
        var tableNumParts = tableNum.split('_');
        tableNum = tableNumParts.length > 0 ? tableNumParts[tableNumParts.length -1] : tableNum;

        var $qty = $tb.find('.qty.hidden');
        var $price = $tb.find('.item-total.hidden');
        var $itemPrice = $tb.find('.item-price.hidden');
        var tierPrices = $itemPrice.data('tier_prices');
        var total = 0;

        var $currentPrice = $tb.find('.item-price-copy');
        var $qtyCopy = $tb.find('.qty-copy');
        $itemPrice.val($currentPrice.val());

        var itemQty = $qtyCopy.val();
        $qty.val(itemQty);

        // Process tier prices
        var applyPrice = $itemPrice.val();
        var tierQty = 0;
        if (tierPrices !== undefined) {
            $.each(tierPrices, function(idx, val){
                var tierItemQty = parseFloat(val.qty);
                if (itemQty >= tierItemQty && tierItemQty >= tierQty) {
                    tierQty = tierItemQty;
                    applyPrice = val.price;
                }
            });
        }

        applyPrice = accounting.toFixed(applyPrice, window.accounting.settings.currency.precision);
        $currentPrice.val(applyPrice);
        total = itemQty * $currentPrice.val();

        $price.html(accounting.formatMoney(total));
        $price.attr('data-original-title', total);
        $tb.find('.total-copy_' + tableNum).text($price.text());
    },

    cancelEdit: function() {
        history.back();
    },

    /* ========================================= */
    /* ==== [FUNCTION] clearRow(rows, type) ==== */
    /* ========================================= */

    clearRow: function(rows, type) {
        var unspscSelect2Options = bq.quotes.setUnspsc;
        for(var i = 0; i < rows.length; i++){
            var tableNum = rows.closest('table').attr('id');
            //tableNum = tableNum.substr(tableNum.length - 1, tableNum.length);

            var tableNumParts = tableNum.split('_');
            tableNum = tableNumParts.length > 0 ? tableNumParts[tableNumParts.length -1] : tableNum;

            $(rows[i]).find('[name*="item"]').each(function(){
                var $this = $(this);

                if( ($this.is(':text') || $this.is(':hidden') )
                    && !$this.is('select')
                ) {
                    $this.val('');
                };
                if(bq.helper && bq.helper.validation){
                    bq.helper.validation.clearStatus($this);
                }
            });

            $(rows[i]).find('[class*="item"]').not(':input').not('.select2-container').each(function(){
                var $this = $(this);
                $this.html('');
            });

            $(rows[i]).find('.hidden').each(function(){
                var $this = $(this);

                $this.is(':hidden') ? $this.val('') : $this.text('');

                if($this.attr('data-original-title') != ''){
                    $this.attr('data-original-title', '');
                }
            });

            $(rows[i]).find('.total-copy_' + tableNum).text('');
            $(rows[i]).find('.qty-copy').val('');

            var $tb = $(rows[i]).closest('table');
            var $catalog = $tb.find('.catalog_product');
            var $service = $tb.find('.non-catalog_product');
            var catTmpData = $catalog.attr('data-validate-multiple');
            var srvTmpData = $service.attr('data-validate-multiple');
            var $type = $tb.find('input:radio[name="' + $catalog.attr('name') + '"]');

            $catalog.val('product');
            $catalog.attr('data-validate-multiple', catTmpData.replace(/\d/g, tableNum));
            $service.val('service');
            $service.attr('data-validate-multiple', srvTmpData.replace(/\d/g, tableNum));

            $tb.find('input.unspsc.select-box').select2('val', '');
            $tb.find('select.unit_of_measure').select2('val', '');
            $tb.find('input.selectbox-data').select2('val', '');

            if(!$catalog.prop('checked') && type === 'new') {
                $type.each(function(){
                    $(this).prop('checked', false);
                });

                $catalog.prop('checked', true);

                for(var x = 0; x < rows.length; x++){
                    $(rows[x]).removeClass('non-catalog');
                }

            } else if (!$catalog.prop('checked') && type !== 'new') {
                $($(rows[i]).find('.select2-container')).removeClass('select2-container-disabled');
                $($(rows[i]).find('.name,.unspsc,.unit_of_measure,.manufacturer_name,.manufacturer_part_number'))
                    .prop('disabled', null);
            }
        }
        this.fixRow(rows);
    },

    /* ================================= */
    /* ==== [FUNCTION] fixRow(rows) ==== */
    /* ================================= */

    fixRow: function(rows) {
        var catalog = $(rows).closest('table').find('.catalog_product').is(':checked');
        if (catalog) {
            for(var i = 0; i < rows.length; i++){
                $(rows[i]).find('.select2-container').addClass('select2-container-disabled');
                $($(rows[i]).find('.itemtype, .name,.unspsc,.unit_of_measure,.manufacturer_name,.manufacturer_part_number'))
                    .prop('disabled', 'disabled');

            }
        }
    },

    /* ============================================ */
    /* ==== [FUNCTION] updateRows(data, table) ==== */
    /* ============================================ */

    updateRows: function(data, table) {
        var $tb = table;
        var $self = this,
            count = $self.tableCount + 1;
        var $id = 0,
            unspscSelect2Options = bq.quotes.setUnspsc;

        if( !$tb ) {
            $tb = $self.getLineRowTemplate();
            $tb.prop('id', 'quotations-table_' + count);
            var rowQtyClass = 'qty-copy_' + count;
            $tb.attr('data-sku-input', 'sku-item_' + count);
            $tb.attr('data-qty-input', rowQtyClass);

            // New row qty input
            var $qtyInput = $('.qty.hidden', $tb);
            if ($qtyInput.hasClass('qty-copy_0')) $qtyInput.removeClass('qty-copy_0');
            $qtyInput.addClass(rowQtyClass);

            $('.qty-copy', $tb).prop('min','1');
            $('.qty-copy', $tb).prop('max','');

            $tb = $($tb[0]);
            $tb.find('.sku').data('validateSku', true).data('lastSku', '');
        } else {
            $id = $tb.prop('id');
        }

        var $rows = $tb.children('tbody').children('tr');

        $tb.find('[name*="item"], [name*="prod_service"]').each(function(){
            var $this = $(this);
            var tmpId = $this.prop('id');
            var tmpName = $this.prop('name');

            if( ($this.is(':text') || $this.is(':hidden') )
                && !$this.is('select')
            ) {
                $this.val('');
            };
            $this.prop('name', tmpName.replace(/\d/, count));
            $this.prop('id', tmpId.replace(/\d/, count));
            $this.prev().prop('for', tmpId.replace(/\d/, count));

            if (bq.helper && bq.helper.validation) {
                 bq.helper.validation.clearStatus($this);
            }
        });

        $tb.find('[id*="prod_type"]').each(function(){
          var $this = $(this);
          var tmpId = $this.prop('id');
          $this.prop('id', tmpId.replace(/\d/g, count));
        });

        var hasNum = /\d/;
        var elSet = {
            'sku-item_' : $($tb.find('[class*="sku-item_"]')),
            'total-copy_' : $($tb.find('[class*="total-copy_"]')),
            'unspsc-copy_' : $($tb.find('[class*="unspsc-copy_"]')),
            'unit_of_measure-copy_' : $($tb.find('[class*="unit_of_measure-copy_"]'))
        };

        $($tb.find('[class*="qty-copy"]')).val('1');

        for(var key in elSet){
            var obj = elSet[key];
            var classes = $(obj).attr('class').split(/\s+/);

            for(var i = 0; i < classes.length; i++){
                if(hasNum.test(classes[i])){
                    obj.removeClass(classes[i]).addClass(key + count);
                }
            }
        }

        // Remove rendered select2 DOM elements
        $tb.find('.select2-container.select-box').remove();
        $tb.find('.quote-item-accounting .select-form-element .select2-container.selectbox-data').remove();
        // Show source elements so resulting select2 DOM subtree will be also visible. And after init, source elements will be hidden
        $tb.find('.form-control.select-box').css('display', '');
        $tb.find('.quote-item-accounting .select-form-element .form-control').css('display', '');

        $tb.find('.is-select2:input').prop('id', '').removeData();
        $tb.find('.remove').prop('id', '').prop('title', 'Remove').prop('text', 'Remove').removeData().tooltip('destroy');

        if(data && data.id) {
            $tb.find('.catalog_product').prop('checked', true);
            $rows.removeClass('non-catalog');
        } else if (data) {
            $tb.find('.non-catalog_product').prop('checked', true);
            $rows.addClass('non-catalog');
        }

        $self.clearRow($rows, 'new');

        if ($('table.form-set').last().hasClass('table-striped')){
            $tb.removeClass('table-striped');
            $tb.insertAfter($('table.form-set').last());
        } else {
            $tb.addClass('table-striped');
            $tb.insertAfter($('table.form-set').last());
        }

        $self.tableCount = count;

        $tb.find('input.unspsc.select-box').select2(unspscSelect2Options);
        $tb.find('select.unit_of_measure').select2();
        if ($tb.find(`select.itemtype.select-box`).length) {
            $tb.find('select.itemtype.select-box').select2({minimumResultsForSearch: 3});
        }

        $tb.find('.select2-focusser').each(function() {
          if($(this).attr('data-validate-id') === undefined) {
            var valId = Math.floor(1000 + Math.random() * 9000);
            $(this).attr('data-validate-id', valId);
            $(this).removeAttr('tabindex');
          }
        });

        /* -- Set Hidden Fields -- */
        $tb.find('[name*="hidden"]').each(function(){
            var $this = $(this);
            var tmpName = $this.attr('name');
            $this.attr('name', tmpName.replace(/\d/g, count));
        });

        if(data && data.sku){
            if(data.id){
                /* -- Catalog Product -- */
                $rows.each(function(){
                    $(this).removeClass('non-catalog');
                });

                $tb.find('.product-id').val(data.id);
                $tb.find('.sku').val(data.sku)
                    .prop('placeholder', bq.messages.quote.updateGlobalSearch)
                    .data('validateSku', true)
                    .data('lastSku', data.sku);

                $tb.find('.item-name').html(data.name);
                $tb.find('input[name*="[caption]"]')
                    .prop('disabled', true)
                    .val(data.name);
                $tb.find('.item-price-copy').val(data.price);
                $tb.find('.qty-copy').val(data.qty);


                $tb.find('.hidden').each(function(){
                    var $this = $(this);
                    var i = 'hidden[' + count + ']';
                    var tmpName = $this.attr('name');
                    var total = data.price * data.qty;

                    if(tmpName == (i + '[unspsc]')){
                        if(data.unspsc){ $this.text(data.unspsc); }
                    } else if(tmpName == (i + '[uom]')){
                        if(data.uom){ $this.text(data.uom); }
                    } else if(tmpName == (i + '[qty]')){
                        $this.val(data.qty);
                    } else if(tmpName == (i + '[price]')){
                        $this.val(data.price);
                    } else if(tmpName == (i + '[total]')){
                        $this.html(accounting.formatMoney(data.price * data.qty));
                        $this.attr('data-original-title', (data.price * data.qty));
                    }
                });

                $tb.find('.total-copy_' + count).html(accounting.formatMoney(data.price * data.qty));

                var $price = $tb.find('.item-price');
                $price.is(':input') ? $price.val(data.price) : $price.html(data.price);

                /* -- XAT Attributes -- */
                if(data.manufacturer_name){
                    $tb.find('.item-manufacturer_name').text(data.manufaturer_name);
                    $tb.find('input[name*="[manufacturer_name]"]').val(data.manufacturer_name);
                }
                if(data.manufacturer_part_number) {
                    $tb.find('.item-manufacturer_part_number').text(data.manufacturer_part_number);
                    $tb.find('input[name*="[manufacturer_part_number]"]').val(data.manufacturer_part_number);
                }

                if(data.uom) {
                    $tb.find('select[name*="[unit_of_measure]"]')
                        .prop('disabled', true)
                        .select2('data', {id: data.uom, text: data.uom, disabled: false});
                    $tb.find('.unit_of_measure-container.select2-container')
                        .addClass('select2-container-disabled');
                }

                if(data.unspsc) {
                    $tb.find('input[name*="[unspsc]"]')
                        .prop('disabled', true)
                        .select2('data', {id: data.unspsc, text: data.unspsc, disabled: false});
                    $tb.find('.unspsc-container.select2-container')
                        .addClass('select2-container-disabled');
                }

                if (data.item_type) {
                    $tb.find('select[name*="[item_type]"]')
                        .prop('disabled', true)
                        .select2('val', data.item_type);
                }

                /* -- Set Classes & Selected -- */
                $tb.find('.catalog_product').prop('checked', true);
                $tb.find('.non-catalog_product').prop('checked', false);
                $tb.children('tr').each(function(){
                    $(this).removeClass('non-catalog');
                });
            } else {
                /* -- Non-Catalog Product -- */
                $rows.each(function(){
                    $(this).addClass('non-catalog');
                });

                $tb.find('.select2-container').show();
                $tb.find('.product-id').val('');
                $tb.find('.sku').val(data.sku)
                    .prop('placeholder', '')
                    .data('validateSku', false)
                    .data('lastSku', '');

                $tb.find('input[name*="[caption]"]')
                    .prop('disabled', false)
                    .val(data.name);
                $tb.find('.item-price-copy').val(data.price);
                $tb.find('.qty-copy').val(data.qty);


                $tb.find('.hidden').each(function(){
                    var $this = $(this);
                    var i = 'hidden[' + count + ']';
                    var tmpName = $this.attr('name');
                    var total = data.price * data.qty;

                    if(tmpName == (i + '[unspsc]')){
                        if(data.unspsc){ $this.text(data.unspsc); }
                    } else if(tmpName == (i + '[uom]')){
                        if(data.uom){ $this.text(data.uom); }
                    } else if(tmpName == (i + '[qty]')){
                        $this.val(data.qty);
                    } else if(tmpName == (i + '[price]')){
                        $this.val(data.price);
                    } else if(tmpName == (i + '[total]')){
                        $this.html(accounting.formatMoney(data.price * data.qty));
                        $this.attr('data-original-title', (data.price * data.qty));
                    }
                });

                $tb.find('.total-copy_' + count).html(accounting.formatMoney(data.price * data.qty));

                /* -- XAT Attributes -- */
                if (data.manufacturer_name) {
                    $tb.find('.manufacturer_name').val(data.manufacturer_name);
                    $tb.find('input[name*="[manufacturer_name]"]')
                        .prop('disabled', false)
                        .val(data.manufacturer_name);
                }
                if (data.manufacturer_part_number) {
                    $tb.find('.manufacturer_part_number').val(data.manufacturer_part_number);
                    $tb.find('input[name*="[manufacturer_part_number]"]')
                        .prop('disabled', false)
                        .val(data.manufacturer_part_number);
                }

                if (data.uom) { //handle select2 plugin
                    $tb.find('select[name*="[unit_of_measure]"]')
                        .prop('disabled', false)
                        .select2('data', {id: data.uom, text: data.uom, disabled: false});
                    $tb.find('.unit_of_measure-container.select2-container')
                        .removeClass('select2-container-disabled');
                }

                if (data.unspsc) { //handle select2 plugin
                    $tb.find('input[name*="[unspsc]"]')
                        .prop('disabled', false)
                        .select2('data', {id: data.unspsc, text: data.unspsc, disabled: false});
                    $tb.find('.unspsc-container.select2-container')
                        .removeClass('select2-container-disabled');
                }

                $tb.find('input.selectbox-data').show();
                if (data.accounting) {
                    $.each(data.accounting, function(idx, val){
                        $tb.find('input.bq-accounting-'+ idx).data('customSelection', val);
                        $tb.find('input.bq-accounting-'+ idx).val(val);
                        $tb.find('.bq-accounting-' + idx + ' span.select2-chosen').text(val);
                    });
                }

                if (data.item_type) { //handle select2 plugin
                    $tb.find('select[name*="[item_type]"]')
                        .prop('disabled', false)
                        .select2('val', data.item_type);
                }

                /* -- Set Classes & Selected -- */
                $tb.find('.catalog_product').prop('checked', false);
                $tb.find('.non-catalog_product').prop('checked', true);
                $tb.children('tr').each(function(){
                    $(this).addClass('non-catalog');
                });

            }
        }

        this.fixRow($rows);
        this.updateSummary();

        if (bq.global.bootstrapFixes) { bq.global.bootstrapFixes(); }
        if (bq.global.tooltipSetup) { bq.global.tooltipSetup(); }
    },

    /* ==================================================== */
    /* ==== [FUNCTION] updateSummary(skipInitializeJS) ==== */
    /* ==================================================== */

    updateSummary: function(skipInitializeJS) {
        var $self = this;
        var totalFields = $self.form.find('.item-total.hidden');
        var totals = [];
        var summaryTotal = 0;
        var summaryCount = 0;

        totalFields.each(function(){
            var $td = $(this).closest('table');
            var $q = $td.find('.qty-copy').val();
            var $i = $td.find('.item-price-copy').val();
            var total = $i * $q;
            totals.push(total);
            $self.updateObj($td);
        });

        for(var i = 0; i < totals.length; i++){
            summaryTotal = summaryTotal + parseFloat(totals[i]);
            summaryCount++;
        }

        $('.quote-summary-count').html(summaryCount);
        $('.quote-summary-total').text(accounting.formatMoney(summaryTotal));
        if (!skipInitializeJS) {
            bq.initializeJS();
        }
    },

    /* ===================================== */
    /* ==== [FUNCTION] updateObj(table) ==== */
    /* ===================================== */

    updateObj: function(table){
        var $tb = table;
        var tbNum = $tb.attr('id');
        // tbNum = tbNum.charAt(tbNum.length - 1);

        var tableNumParts = tbNum.split('_');
        tbNum = tableNumParts.length > 0 ? tableNumParts[tableNumParts.length -1] : tbNum;

        var objSet = ['name', 'manufacturer_name', 'manufacturer_part_number', 'unspsc', 'unit_of_measure'];
        var catalog = $tb.find('.catalog_product').is(':checked');

        for (var i = 0; i < objSet.length; i++){
            var $el = $tb.find('input[name*="[' + objSet[i] + ']"]');
            if ($el.val() == ''){
                switch(objSet[i]){
                    case 'name':
                        $el.val($tb.find('.item-name').text());
                        break;
                    case 'manufacturer_name':
                        $el.val($tb.find('.item-manufacturer_name').text());
                        break;
                    case 'manufacturer_part_number':
                        $el.val($tb.find('.item-manufacturer_part_number').text());
                        break;
                    case 'unit_of_measure':
                        var copy = catalog ? '.unit_of_measure-copy_' + tbNum : '.unit_of_measure .select2-chosen';
                        $el.val($tb.find(copy).text());
                }
            }
        }

    },


    /* ========================================= */
    /* ==== [FUNCTION] update_combo_boxes() ==== */
    /* ========================================= */

    update_combo_boxes: function() {
        $('.select2-focusser.required-entry').removeClass('required-entry');
    },

    /* ====================================== */
    /* ==== [FUNCTION] submitQuoteForm() ==== */
    /* ====================================== */

    submitQuoteForm: function() {
        $('#requester_id').removeAttr('disabled');
        this.clearQuoteError();
        this.clearItemsError();

        var $self = this;
        var formData = bq.helper.formToObject( $self.form );

        var data = {
            items : formData.item,
            generalInfo : formData
        };

        data.items.count = data.items.length;
        //$('#quote-new').trigger('bq.viewhandler.start');
        $.ajax({
            url : submitAjaxURL,
            type : 'post',
            data : data,
            dataType: 'json'
        }).done(function(response){
            if(response.redirect){
                bq.quotes.isUrlAllowChange = true;
                window.location.href = response.redirect
            } else { //only stop if there was not a forward
              $('#quote-new').trigger('bq.viewhandler.stop');
            }

            $('#create-quote-form').data('submitting', false);
            if (response.error) {
                $self.setQuoteError(response.error);
                $self.setSaveBtn('');
            }
            if (response.validation_message) {
                $.each(response.validation_message, function (key, fieldValidationErrors) {
                    var fieldType = Object.keys(fieldValidationErrors);
                    $.each(fieldType, function(fieldTypeKey, value){
                        var fieldId = 'item\\[' + key + '\\]\\[' + value + '\\]';
                        var fieldElement = $('#' + fieldId);
                        $self.showFieldValidationError(fieldElement, {fieldValidationErrors: [fieldValidationErrors[value]]})
                    });
                });
            }

        }).fail(function(response){
            $('#create-quote-form').data('submitting', false);
            $self.setQuoteError(bq.messages.quote.saveError);
            $self.setSaveBtn('');
            $('#quote-new').trigger('bq.viewhandler.stop');
        });
    },

    /* ===================================== */
    /* ==== [FUNCTION] showFieldValidationError(field, messages) ==== */

    showFieldValidationError: function (field, messages) {
        var $self = this;
        var icon = $('<span class="fa fa-exclamation-triangle text-error form-control-feedback form-validation-error"></span>');
        var label = $self.classHandler(field).find('label').first();
        var fieldType = Object.keys(messages);
        icon.attr('data-original-title', messages[fieldType][0]);
        icon.tooltip({});
        if( label.length >= 1 && !(label.hasClass("sr-only") || label.parent('div').hasClass("sr-only"))  && !label.hasClass('element-radio') && !label.hasClass('select2-offscreen')) {
            label.prepend(icon);
        } else {
            var e = $self.classHandler(field);
            if(e.hasClass('attachment-block')) {
                e.find('.attachment-block-table tr:first-child .upload-file-name').append(" ").append(icon);
            } else {
                e.prepend(icon);
                e.addClass('has-error has-feedback');
            }
        }

    },

    classHandler: function (el) {
        return (el.closest('.form-group').length) ? el.closest('.form-group') : el.parent();
    },


    /* ===================================== */
    /* ==== [FUNCTION] setSaveBtn(type) ==== */
    /* ===================================== */

    setSaveBtn: function(type) {
        var $self = this;
        if(type == 'loading') {
            $('#create-quote-submit-button').prop('disabled', true);
            $('#create-quote-submit-button').html(bq.messages.quote.uploadSpinNon);
        } else {
            $self.restoreSubmitButtonEvents();
            $('#create-quote-submit-button').prop('disabled', false);
            $('#create-quote-submit-button').html(bq.messages.quote.uploadCreate);
            var $form = $('#quote-new').find('form');
            var alreadyValidated = $form.data('alreadyValidated');
            $form.data('alreadyValidated', false);
            $('#create-quote-submit-button').removeClass('disabled');
        }
    },

    /* ===================================== */
    /* ==== [FUNCTION] setfileBtn(type) ==== */
    /* ===================================== */

    setFileBtn: function(type) {
        if(type == 'loading') {
            $('#bqat-btnSubmitUpload').prop('disabled', true).html(bq.messages.quote.uploadSpin);
        } else {
            $('#bqat-btnSubmitUpload').prop('disabled', false).html(bq.messages.quote.uploadPopulate);
        }
    },

    /* ===================================================== */
    /* ==== [FUNCTION] setFileMessage(msg, type, clear) ==== */
    /* ===================================================== */

    setFileMessage: function(msg, type, clear) {
        var $container = $('#file-upload-message');

        if(clear) {
            $container.html('');
            return;
        }

        $container.html('<div class="alert alert-'+type+'">'+msg+'</div>');
    },

    /* ====================================== */
    /* ==== [FUNCTION] processFile(json) ==== */
    /* =================================-==== */

    processFile: function(json) {
        var table = this.form;
        var $self = this;

        $.each(json, function(key, val){
            $self.updateRows(val);
        });

        this.removeEmptyRows();
        this.form.find('table.form-set').each(function(){
            $(this).trigger('bq.gridSummary.change', this);
        });
        this.initListeners();
    },

    /* ====================================== */
    /* ==== [FUNCTION] removeEmptyRows() ==== */
    /* ====================================== */

    removeEmptyRows: function(){
        this.form.find('table').each(function(index) {
            var $row = $(this);
            var $sku = $row.find('.sku.form-control');

            if($sku.val() == '' || $sku.val() == undefined) {
               $row.find('.remove').click();
            }
        });
    },

    recalculateRemoveClearButtons: function(){
        var itemsCount = this.form.find('table.form-set').length;
        var buttonPhrase = itemsCount > 1 ? 'Remove' : 'Clear';
        this.form.find('table.form-set').each(function(index) {
            $(this).find('.remove')
                .prop('title', buttonPhrase)
                .prop('text', buttonPhrase)
                .attr('data-title', buttonPhrase)
                .attr('data-original-title', buttonPhrase);
        });
    },

    /* ================================================= */
    /* ==== [FUNCTION] validateItemsForm(clearRows) ==== */
    /* ================================================= */

    validateItemsForm: function() {
        var $self = this;
        var $rows = $self.form.find('table[data-bq] tbody');
        var $error = false;
        var $errorType = '';
        var fieldErrorTpl = bq.messages.quote.valEmptyField;

        if( $rows.length == 0 ) {
            /* -- none or template row -- */
            $error = bq.messages.quote.valCreateErrorOne;
            $errorType='min-item-qty-error';
        } else {
            /* -- multiple rows -- */
            $rows.each(function(index) {
                var $this = $(this);
                var res = $self.validateRow($this);
                var _fieldErrorTpl = fieldErrorTpl;

                if( res !== true ) {
                  $error = bq.messages.quote.valCreateError + '<br />';
                  $error += _fieldErrorTpl.replace(/%s/g, res);
                  $errorType = 'item-field-error';
                }
            });
        }

        if( $error ) {
            $self.setItemsError($error,$errorType);
            return false;
        } else {
            $self.clearItemsError();
        }

        return true;
    },

    validateGeneralFields: function () {
        var $self = this;
        var $errors = this.form.find('.general-information').find('.has-error');
        var result = $errors.length === 0;
        if (!result) {
            var fields = [];
            $errors.each(function(index, el) {
                var message = ParsleyUI.getErrorsMessages($(el).find('[data-validate-id].form-control').parsley());
                message = Array.isArray(message) && message.length ? message[0] : message;
                if (message) {
                    var fieldName = $(el).find('label').text().replace('*', '').trim();
                    fields.push('<p>' + fieldName + ': ' + message + '</p>');
                }
            });
            fields.length && $self.setQuoteError(fields.join(''));
        }
        return result;
    },

    /* ====================================== */
    /* ==== [FUNCTION] clearItemsError() ==== */
    /* ====================================== */

    clearItemsError: function() {
        $('#itemsFormError').html('');
    },

    /* ======================================================= */
    /* ==== [FUNCTION] setItemsError(msg, errorTypeClass) ==== */
    /* ======================================================= */

    setItemsError: function(msg, errorTypeClass) {
        $('#itemsFormError').html('<div class="alert alert-danger '+errorTypeClass+'">'+msg+'</div>');
    },

    /* ====================================== */
    /* ==== [FUNCTION] clearQuoteError() ==== */
    /* ====================================== */

    clearQuoteError: function() {
        $('#quoteFormError').html('');
    },

    /* ======================================= */
    /* ==== [FUNCTION] setQuoteError(msg) ==== */
    /* ======================================= */

    setQuoteError: function(msg) {
        $('#quoteFormError').html('<div class="alert alert-danger">'+msg+'</div>');
    },

    /* ========================================= */
    /* ==== [FUNCTION] hasItemsFormErrors() ==== */
    /* ========================================= */

    hasItemsFormErrors: function(){
        /* -- Returns true if the table is currently displaying errors of any kind. -- */
        return $('#itemsFormError').children().length > 0;
    },

    /* =========================================== */
    /* ==== [FUNCTION] hasItemQuantityError() ==== */
    /* =========================================== */

    hasItemQuantityError: function(){
        /* -- Returns true if the item table has errors due to validation of minimum required items.
        * @returns {*|boolean} Returns true if there is a minimum number of items error, false otherwise.
        -- */
        return this.hasItemsFormErrors() && $('#itemsFormError').children('.min-item-qty-error').length > 0;
    },

    /* ===================================== */
    /* ==== [FUNCTION] validateRow(row) ==== */
    /* ===================================== */

    validateRow: function(row) {
        //var $td = row.closest('table');
        var catalog = row.find('.catalog_product').is(':checked');

        if( row.find('.has-error').length > 0 && !catalog ) {
            return false;
        }

        /* -- list data -- */
        var _values = {};

                _values.SKU = row.find('input[name*="[sku]"]').length ? (row.find('input[name*="[sku]"]').val().length >= 1) : true;
        _values.Description = row.find('input[name*="[name]"]').length ? (row.find('input[name*="[name]"]').val().length >= 1) : true;
             _values.UNSPSC = row.find('input[name*="[unspsc]"]').length ? (row.find('input[name*="[unspsc]"]').val().length >= 1) : true;
              _values.Price = row.find('input[name*="[price]"]').length ? (row.find('input[name*="[price]"]').val().length >= 1) : true;
                _values.Qty = row.find('.qty-copy').length ? (row.find('.qty-copy').val().length >= 1) : true;
                _values.UOM = row.find('select.unit_of_measure').length ? (row.find('select.unit_of_measure').val() != undefined && row.find('select.unit_of_measure').val() != '') : true;

        if( catalog ){ //catalog
            _values.id = row.find('.qo-id:input').val().length >= 1;
            if (!_values.UOM){ _values.UOM = row.find('.item-unit_of_measure').text().length >= 1; }
            if (!_values.UNSPSC){ _values.UNSPSC = row.find('.item-unspsc').text().length >= 1; }
        }

        var valid = true;

        for( var key in _values ){
            if ( !_values[key] && key == 'id' ) {
                valid = false;
            } else if (!_values[key]) {
                valid = key;
            }
        }

        return valid;
    },

    /* ================================================ */
    /* ==== [FUNCTION] restoreSubmitButtonEvents() ==== */
    /* ================================================ */

    restoreSubmitButtonEvents: function() {
        /* -- fix for ajax responce with error in json -- */
        // changed to a normal submit button, shouldnt need this
        //$('#create-quote').click(function(e) { $('#create-quote-form').submit(); });
    },

    /* ========================================= */
    /* ==== [FUNCTION] getLineRowTemplate() ==== */
    /* ========================================= */

    getLineRowTemplate: function() {
        var tables = $(this.form).find('table.form-set'),
             clone = tables[0];

        return $(clone).clone();
    }
}


bq.quotes.setUnspsc = {
    minimumInputLength: 2,
    placeholder: bq.messages.quote.unspscPlaceholder,
    multiple: false,

    initSelection: function(element, callback){
        var tmp = ($(element).data('customSelection') == $(element).val());

        if(!tmp) {
            var id=$(element).val();
            $(element).data('customSelection', id);

            if (id!=="") {
                $.ajax(bq.urls.quote.unspscInitAjaxURL, {
                    data: {
                        search: id,
                        page_limit:1,
                        source_model_encrypted: bq.messages.quote.unspscAjaxSource,
                    },
                    dataType: "json"
                }).done(function(data) {
                    if(data.length) { data = data.pop(); }
                    if(!data.id) { $(element).val(''); }
                    callback(data);
                });
            }
        }
    },
    ajax: {
        url: bq.urls.quote.unspscAjaxURL, //get list of valid UNSPSC codes
        dataType: 'json',
        data: function(term, page) {
            return {
                search: term,
                page: page,
                page_limit: 30,
                source_model_encrypted: bq.messages.quote.unspscAjaxSource,
            };
        },
        results: function (data, page) {
            return { results: data };
        }
    }
};

if ($('#create-quote-form')) {
    bq.quotes.prototype.init();
}

var quotationEditInit = function () {
    var $editForm = $('#create-quote-form.quotation-edit');
    if ($editForm.data('quotationEditInitialized')) {
        return;
    }
    // Update line totals for rendered items
    $editForm.find('table[data-bq="quick-order"]').each(bq.quotes.prototype.updateLineTotals)
    if ($editForm.length) {
        bq.quotes.prototype.updateSummary(true);
        window.addEventListener('beforeunload', function(e) {
            if (!bq.quotes.isUrlAllowChange) {
                e.preventDefault();
                e.returnValue = '';
            }
        });
    }
    $editForm.data('quotationEditInitialized', true);
};

bq.init.push(quotationEditInit);
